import { ResultError } from './ResultError.js';
class Ok {
    constructor(value) {
        this.value = value;
    }
    get isOk() {
        return true;
    }
    get isErr() {
        return false;
    }
    get error() {
        return ResultError.raise(this, 'ERR_NOT_ERR', 'Cannot access `error` on an Ok instance.', Object.getOwnPropertyDescriptor(this.constructor.prototype, 'error')
            .get);
    }
    map(fn) {
        return new Ok(fn(this.value));
    }
    mapErr() {
        return this;
    }
    chain(next) {
        return next(this.value);
    }
    chainErr() {
        return this;
    }
    unwrap() {
        return this.value;
    }
    unwrapOr() {
        return this.value;
    }
    unwrapOrElse() {
        return this.value;
    }
    unwrapErr() {
        return ResultError.raise(this, 'ERR_NOT_ERR', 'Cannot `unwrapErr` an Ok instance.', Object.getOwnPropertyDescriptor(Ok.prototype, 'unwrapErr').get);
    }
    unwrapErrOr(fallback) {
        return fallback;
    }
    unwrapErrOrElse(fallback) {
        return fallback(this.value);
    }
    unpack() {
        return this.value;
    }
    match(okMatcher) {
        return okMatcher(this.value);
    }
    tap(fn) {
        fn(this.value);
        return this;
    }
    tapErr() {
        return this;
    }
    unwrapOrThrow() {
        return this.value;
    }
    *[Symbol.iterator]() {
        return this.value;
    }
    biMap(okFn) {
        return this.map(okFn);
    }
    biChain(okFn) {
        return okFn(this.value);
    }
    asTuple() {
        return [true, undefined, this.value];
    }
    get [Symbol.toStringTag]() {
        return 'Ok';
    }
}
Object.setPrototypeOf(Ok.prototype, null);
Object.defineProperty(Ok, 'name', {
    value: 'Ok',
    writable: false,
    enumerable: false,
    configurable: false,
});
export const OkImpl = Ok;
export const ok = (value) => new Ok(value);
export const asyncOk = async (value) => ok(await value);
